import styled from 'styled-components';

export const Container = styled.div`
    display:flex;
    flex-direction: row;
    height:100%;
    justify-content: center;
    align-items: baseline;

`;

export const ContainerForm = styled.div`
    //display: flex;
    //flex-direction: column;
    //align-items:center;

    display:grid;
    grid-template-rows: 1fr;
    padding: 15px;
`;

